import { render, staticRenderFns } from "./PricingDetail.vue?vue&type=template&id=8ce287b4&scoped=true&"
import script from "./PricingDetail.vue?vue&type=script&lang=ts&"
export * from "./PricingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PricingDetail.vue?vue&type=style&index=0&id=8ce287b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce287b4",
  null
  
)

export default component.exports